import type { NestedKeys } from '../../types.ts';

/**
 * `en` · `common` namespace — app-wide strings shared across every surface.
 * Leaf values may hold `{placeholder}` tokens interpolated by the translator.
 */
export const common = {
  app: {
    name: '4fantasia',
    tagline: 'Your AI companion, always here',
  },
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    continue: 'Continue',
    delete: 'Delete',
    retry: 'Try again',
  },
  nav: {
    chat: 'Chat',
    gallery: 'Gallery',
    settings: 'Settings',
    referrals: 'Referrals',
  },
  greeting: 'Welcome back, {name}',
} as const;

export type CommonMessages = typeof common;

/** Typo-safe dot-path keys for the `common` namespace. */
export type CommonKey = NestedKeys<CommonMessages>;
